import React from "react";
import { Logo } from "./Logo";

export function Footer({ t }) {
  return (
    <footer className="border-t border-white/10 bg-[#0B132B]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex items-center gap-4">
          <Logo size={32} />
        </div>
        <div
          className="text-[12px] uppercase tracking-[0.22em] text-[#9BA1A6]"
          style={{ fontFamily: "'Manrope', sans-serif" }}
        >
          © {new Date().getFullYear()} Labour Engine — {t.footer.rights}
        </div>
      </div>
    </footer>
  );
}
